<template>
  <div v-el:toolbar id="toolbar">
    <select class="ql-font">
      <option selected="selected"></option>
      <option value="serif"></option>
      <option value="monospace"></option>
    </select>
    <select class="ql-size">
      <option value="small"></option>
      <option selected></option>
      <option value="large"></option>
      <option value="huge"></option>
    </select>
    <button class="ql-bold" title="Bold"></button>
    <button class="ql-italic" title="Italic"></button>
    <button class="ql-strike" title="Strike"></button>
    <button class="ql-underline" title="Underline"></button>
    <button class="ql-link" title="Link"></button>
    <button type="button" class="ql-list" value="ordered"></button>
    <button type="button" class="ql-list" value="bullet"></button>
    <select class="ql-align">
      <option selected="selected"></option>
      <option value="center"></option>
      <option value="right"></option>
      <option value="justify"></option>
    </select>
    <select class="ql-color">
      <option selected="selected"></option>
      <option value="#e60000"></option>
      <option value="#ff9900"></option>
      <option value="#ffff00"></option>
      <option value="#008A00"></option>
      <option value="#0066cc"></option>
      <option value="#9933ff"></option>
      <option value="#ffffff"></option>
      <option value="#facccc"></option>
      <option value="#ffebcc"></option>
      <option value="#ffffcc"></option>
      <option value="#cce8cc"></option>
      <option value="#cce0f5"></option>
      <option value="#ebd6ff"></option>
      <option value="#bbbbbb"></option>
      <option value="#f06666"></option>
      <option value="#ffc266"></option>
      <option value="#ffff66"></option>
      <option value="#66b966"></option>
      <option value="#66a3e0"></option>
      <option value="#c285ff"></option>
      <option value="#888888"></option>
      <option value="#a10000"></option>
      <option value="#b26b00"></option>
      <option value="#b2b200"></option>
      <option value="#006100"></option>
      <option value="#0047b2"></option>
      <option value="#6b24b2"></option>
      <option value="#444444"></option>
      <option value="#5c0000"></option>
      <option value="#663d00"></option>
      <option value="#666600"></option>
      <option value="#003700"></option>
      <option value="#002966"></option>
      <option value="#3d1466"></option>
    </select>
  </div>
  <div :id="componentId" class="gaeditor"></div>
</template>

<script>
  module.exports = {
    ready: function () {
      this.init()
    },
    props: {
      body: {
        type: String,
        twoWay: true
      },
      placeholder: {
        type: String
      },
      componentId: {
        type: String,
        default: 'o'
      }
    },
    methods: {
      init: function () {
        var toolbar = this.$els.toolbar
//        var editor = this.$els.editor
        var editor = document.querySelector('#' + this.componentId)
        this.quill = new window.Quill(editor, {
          modules: {
            'toolbar': {container: toolbar}
          },
          theme: 'snow',
          placeholder: this.placeholder
        })
        document.querySelector('#' + this.componentId + ' .ql-editor').addEventListener('paste', (event) => {
          this.$emit('loadstart')
        })
        if (this.body && this.body !== '') {
          this.quill.pasteHTML(0, this.body)
        }
        this.quill.on('text-change', this.onTextChange)
      },
      onTextChange: function () {
        this.$emit('loadend')
        this.innerChange = true
        this.body = document.querySelector('#' + this.componentId + ' .ql-editor').innerHTML
      }
    },
    watch: {
      'body': function (body) {
        if (!this.innerChange && body !== document.querySelector('#' + this.componentId + ' .ql-editor').innerHTML) {
          this.$emit('loadstart')
          this.quill.pasteHTML(0, body)
          this.$emit('loadend')
        }
      }
    },
    data: function () {
      return {
        quill: {},
        innerChange: false
      }
    }
  }
</script>

<style>
  .gaeditor {
    height: 300px;
  }
</style>



// WEBPACK FOOTER //
// TextArea.vue?375f07d2